import React from 'react';
// TODO: Move these into a /education-icons directory
import HighSchoolIcon from '../HighSchoolIcon';
import AdultLearnerIcon from '../AdultLearnerIcon';
import AssociateDegreeIcon from '../AssociateDegreeIcon';
import BachelorsDegreeIcon from '../BachelorsDegreeIcon';
import SomeGraduateIcon from '../SomeGraduateIcon';
import MastersDegreeIcon from '../MastersDegreeIcon';
import DoctorateDegreeIcon from '../DoctorateDegreeIcon';
import HSDiplomaIcon from '../HSDiplomaIcon';
import SomeCollegeIcon from '../SomeCollegeIcon';
import CircleArrowIcon from '../CircleArrowIcon';
import { educationLevels } from '../../../copy/educationLevels';

export default function EducationIcon({
  educationTextEn,
  tenant,
  height = '80px',
  width = '80px',
}) {
  const getEducationIcon = (educationLevel) => {
    switch (educationLevel) {
      case educationLevels().level1.value:
        return (
          <HighSchoolIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
      case educationLevels().level2.value:
        return (
          <AdultLearnerIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
      case educationLevels().level3.value:
        return (
          <HSDiplomaIcon color={tenant.primary} height={height} width={width} />
        );
      case educationLevels().level4.value:
        return (
          <SomeCollegeIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
      case educationLevels().level5.value:
        return (
          <AssociateDegreeIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
      case educationLevels().level6.value:
        return (
          <BachelorsDegreeIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
      case educationLevels().level7.value:
        return (
          <SomeGraduateIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
      case educationLevels().level8.value:
        return (
          <MastersDegreeIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
      case educationLevels().level9.value:
        return (
          <DoctorateDegreeIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
      default:
        return (
          <CircleArrowIcon
            color={tenant.primary}
            height={height}
            width={width}
          />
        );
    }
  };

  return (
    <div className="center-education-icon">
      {getEducationIcon(educationTextEn)}
    </div>
  );
}
